<template>
    <div class="today-alarm" >
        <div class="middletitleleft dn-title-bg">
            <span>状态概览</span>
        </div>
        <div class="middlelift dn-content-bg table-warp" v-loading="ifLoad">
            <el-table :data="tableData"
                    size="small"
                    style="width: 100%;border-radius:4px;"
                    height="100%"
                    :stripe="true"
                    >
            <el-table-column align="center"
                                :show-overflow-tooltip="true"
                                prop="name"
                                label="分类"></el-table-column>
            <el-table-column align="center"
                                :show-overflow-tooltip="true"
                                prop="realtime"
                                label="实时状态">
                <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                    <el-tag size="medium" :class="scope.row.realtime=='不及格'?realTimeStatuisRed:realTimeStatuisGreen"
                            >{{ scope.row.realtime }}</el-tag>
                </div>
                </template>
            </el-table-column>
            <el-table-column align="center"
                                :show-overflow-tooltip="true"
                                prop="yesterday"
                                label="昨天合格率"></el-table-column>
            <el-table-column align="center"
                                :show-overflow-tooltip="true"
                                prop="lastweek"
                                label="上周合格率"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
let vm
import uuidv1 from 'uuid/v1'
export default {
  props: {
    tableData: {
      type: Array,
      default: () =>[]
    },
    ifLoad:{
        type:Boolean,
        default:false,
    }
  },
  data() {
    return {
        realTimeStatuisRed:'realTimeStatuisRed',
        realTimeStatuis:'realTimeStatuis',
        realTimeStatuisGreen:'realTimeStatuisGreen'
    }
  },
  created() {
      console.log(this.tableData)
  },
  methods: {
    //改表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #F3F3F3;color: #666;'
      }
    },
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
.today-alarm{
    display: flex;
    // flex: 1;
    height:100%;
    width:100%;
    flex-flow: column;
}
.middletitleleft {
//   background: #0197EE;
  color: #fff;
  font-weight: bold;
  display: flex;
  padding: 5px;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.middlelift {
//   border: 1px solid #eee;
  padding-top:5px;
  box-sizing: border-box;
//   background: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
      height: calc( 100% - 33px);
}
.realTimeStatuis{
    border-color: #fff;
    background-color: #fff;
    color:rgb(96, 98, 102)
}
.realTimeStatuisRed{
    border-color: red;
    background-color: red;
    color:#fff
}
.realTimeStatuisGreen{
    border-color: #52CCA3;
    background-color: #52CCA3;
    color:#fff
}
</style>